import { types } from "../types/types";
import EspecialidadesService from "../services/EspecialidadesService";
import { handleErrorApi } from "../helpers/randoms";

export const fetchEspecialidades = (contratos = false) => async (dispatch) => {
    dispatch({ type: types.especialidadesTraer })
    try {
        const result = await (contratos ? EspecialidadesService.traerParaContratos() : EspecialidadesService.traer())
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.especialidadesTraerSucces,
                payload: body
            })
        } else {
            throw body
        }

    } catch (error) {
        dispatch({ type: types.especialidadesTraerError })
        handleErrorApi(dispatch, error, "Error al traer especialidades", "Ha ocurrido un error. Intente nuevamente.")
    }
}
